import { RegisterProps } from '../typings/register'

//Action Types
export const SET_SIGNUP_DATA = "setSignupData";
export const RESET_SIGNUP_DATA = "resetSignupData";

//Action creators
export const setSignupData = (data: RegisterProps) => ({
   type: SET_SIGNUP_DATA,
   data
});


export const resetSignupData = () => ({
   type: RESET_SIGNUP_DATA,
});

const initialState: RegisterProps = {
   email: "",
   password: "",
   appleId: undefined,
   genderId: 0,
   facebookId: undefined,
   languageId: 1,
   date_of_birth: undefined,
   nickName: "",
   profileSentence: "",
   memberLookingFor: undefined,
   dontShowMyAge: false,
   googleId: undefined,
   isTemporary: false,
   registrationTypeId: 1,
   memberCodeTemp: undefined,
   personalStatusId: -1,
   location: undefined,
   aboutMe: '',
   cityId: 1,
   acceptNewsletter: false,
   height: null,
   phoneNumber: "",
}


//Reducer


export default function reducer(state = initialState, action: any) {
   switch (action.type) {
      case SET_SIGNUP_DATA:
         return { ...state, ...action.data };
      case RESET_SIGNUP_DATA:
         return { ...initialState };
      default:
         return state;
   }
}